var map = {
	"./arrow-left.svg": "ac3b",
	"./barkhausen-logo.svg": "1a79",
	"./chevron-up.svg": "bb5d",
	"./close.svg": "8b1b",
	"./communication.svg": "ac20",
	"./energy.svg": "79be",
	"./green.svg": "7a76",
	"./health.svg": "d4c8",
	"./industry.svg": "0e44",
	"./living.svg": "88da",
	"./maximize.svg": "f098",
	"./minus.svg": "3e24",
	"./mobility.svg": "1be0",
	"./play.svg": "dab1",
	"./privacy.svg": "8e22",
	"./routes.svg": "92b1",
	"./triangle-back.svg": "541f",
	"./zoom-in.svg": "d3ec",
	"./zoom-out.svg": "3063"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";